import { render, staticRenderFns } from "./gaokao.vue?vue&type=template&id=416c93fe&scoped=true&"
import script from "./gaokao.vue?vue&type=script&lang=js&"
export * from "./gaokao.vue?vue&type=script&lang=js&"
import style0 from "./gaokao.vue?vue&type=style&index=0&id=416c93fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416c93fe",
  null
  
)

export default component.exports